import { render, staticRenderFns } from "./PropertyDateTime.vue?vue&type=template&id=04f4b6c4&"
import script from "./PropertyDateTime.vue?vue&type=script&lang=js&"
export * from "./PropertyDateTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports